import _taggedTemplateLiteral from "/workspace/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  fragment App_app on App {\n    address\n    appId\n    isForwarder\n    isUpgradeable\n    repoName\n    implementation {\n      address\n    }\n    organization {\n      address\n    }\n    version {\n      ...Version_version\n    }\n    repo {\n      ...Repo_repo\n    }\n    roles {\n      ...Role_role\n    }\n  }\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  fragment Repo_repo on Repo {\n    address\n    name\n    node\n    registry {\n      address\n    }\n    lastVersion {\n      ...Version_version\n    }\n    versions {\n      ...Version_version\n    }\n  }\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  fragment Version_version on Version {\n    semanticVersion\n    codeAddress\n    contentUri\n    artifact\n    manifest\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  fragment Role_role on Role {\n    roleHash\n    manager\n    appAddress\n    grantees {\n      ...Permission_permission\n    }\n  }\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  fragment Permission_permission on Permission {\n    appAddress\n    allowed\n    granteeAddress\n    roleHash\n    params {\n      argumentId\n      operationType\n      argumentValue\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from 'graphql-tag';
export var PERMISSION_FRAGMENT = gql(_templateObject());
export var ROLE_FRAGMENT = gql(_templateObject2(), PERMISSION_FRAGMENT);
export var VERSION_FRAGMENT = gql(_templateObject3());
export var REPO_FRAGMENT = gql(_templateObject4(), VERSION_FRAGMENT);
export var APP_FRAGMENT = gql(_templateObject5(),
/* VERSION_FRAGMENT is already included in REPO_FRAGMENT */
'', REPO_FRAGMENT, ROLE_FRAGMENT);